var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodwinMainLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 277,
    viewBox: "0 0 277 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227 138.5C227 187.377 187.377 227 138.5 227C89.6228 227 50 187.377 50 138.5C50 89.6228 89.6228 50 138.5 50C187.377 50 227 89.6228 227 138.5ZM63.275 138.5C63.275 180.046 96.9544 213.725 138.5 213.725C180.046 213.725 213.725 180.046 213.725 138.5C213.725 96.9544 180.046 63.275 138.5 63.275C96.9544 63.275 63.275 96.9544 63.275 138.5Z",
    fill: "url(#paint0_angular_5085_7564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.85 170.2H166.15M99 107L110.85 154.4H166.15L178 107L154.3 134.65L138.5 107L122.7 134.65L99 107Z",
    stroke: "url(#paint1_angular_5085_7564)",
    strokeWidth: 6.14444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5085_7564",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.5 138.5) rotate(90) scale(88.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#57CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508333,
    stopColor: "#039EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#125674"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    dur: "0.5s",
    values: "-1;0;1;0;-1;",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    dur: "0.5s",
    values: "0;-1;0;1;0;",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "1s",
    values: "0.9;",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_5085_7564",
    cx: 1.25,
    cy: 1,
    r: 3,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.5 138.6) rotate(90) scale(31.6 39.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#57CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508333,
    stopColor: "#039EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#125674"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodwinMainLoader);
export default __webpack_public_path__ + "static/media/goodwin_main_loader.f57012c9447e54a7c0f50f860efa1d17.svg";
export { ForwardRef as ReactComponent };